/**
 * product.equipmentHtml (from GET /live/StandardEquipment/{id}) is a raw HTML
 * table meant for direct display, shaped like:
 *
 *   <span class="headers">DIESEL ENGINE </span><br />
 *   <span class="infotext">Model # D1803-CR-E4-LB2<br />Tier 4 Final Engine<br />...</span>
 *
 * A `<p>`/`<td>`/`<div>` can hold more than one header+infotext pair (e.g.
 * "HYDRAULICS" and "FRONT AXLE" sharing a `<p>`), and there's no wrapper
 * around each pair — so turning this into per-category cards means walking
 * the DOM rather than styling the existing markup in place.
 *
 * This ignores the logo image, the "L Series" / model name row, and the
 * "* * * EQUIPMENT IN STANDARD MACHINE * * *" divider — those are already
 * covered by the print summary's own header/summary box.
 */
export function parseEquipmentHtml(html) {
    if (!html) return [];

    const doc = new DOMParser().parseFromString(html, 'text/html');
    const headers = Array.from(doc.querySelectorAll('span.headers'));

    return headers.map((headerEl) => {
        const title = headerEl.textContent.replace(/\s+/g, ' ').trim();

        // The paired infotext span is the next *element* sibling once you
        // skip past the literal <br> between the header and its content.
        let infoEl = headerEl.nextElementSibling;
        while (infoEl && infoEl.tagName !== 'SPAN') {
            infoEl = infoEl.nextElementSibling;
        }

        const items = infoEl
            ? infoEl.innerHTML
                .split(/<br\s*\/?>/i)
                .map((line) => line
                    .replace(/<[^>]+>/g, '')
                    .replace(/&nbsp;/gi, ' ')
                    .replace(/\s+/g, ' ')
                    .trim())
                .filter(Boolean)
            : [];

        return { title, items };
    }).filter((category) => category.title && category.items.length > 0);
}
